import * as types from "../actions/actiontype";
import * as appUtilityFunction from '../../../infrastructure/apputilityfunctions'
import * as constants from '../constants'

const initialState = {
  fromDate: null,
  toDate: null,
  system: null,
  userBranch: null,
  branch: null,
  module: null,
  agentId: null,
  salesChanelId: null,
  agentsList: [],
  multipleSelectedValues: [],
  selectedAgents: [],
  salesChannelList: [],
  systemMasters: [
    { systemId: 3, title: "Medical Core" },
    { systemId: 2, title: "Individual Portal" },
    { systemId: 4, title: "Medical Group" },
    { systemId: 16, title: "Motor Core" },

  ],
  moduleMasters: [
    { moduleId: 1, title: "Quotation" },
    { moduleId: 2, title: "POLICY" },
  ],
  isAgentorBroker: false
};
initialState.userDashboard = {
  userdashboards: null,
  chartData: null,
  userdashboardData: null,
};
export default function policyReducer(state = initialState, action) {
  switch (action.type) {
    case types.INIT_DASHBOARD: {
      return {
        ...state,
      };
    }
    case types.GET_USER_DASHBOARD_END: {
      //get distict system ids
      const systemIds = [
        ...new Set(action.payload.map((dashboard) => dashboard.systemId)),
      ];
      //map default date
      let fromDate  = constants.DASHBOARD_FROM_DATE;
      let toDate  = appUtilityFunction.formatDate(appUtilityFunction.getAsOfNowDate());
      //map system to sysmeMasters
      const systems = state.systemMasters
        .filter((system) => systemIds.includes(system.systemId))
        .map((system) => ({ systemId: system.systemId, title: system.title }));

      return {
        ...state,
        fromDate: fromDate,
        toDate: toDate,
        systemMasters: systems,
        userDashboard: {
          ...state.userDashboard,
          userdashboards: action.payload,
        },
      };
    }
    case types.GET_DASHBOARD_DATA_END: {
      //    let dashboardData={};
      //  dashboardData[action.payload.dashboardId]=action.payload;
      let v = {
        ...state,
        userDashboard: {
          ...state.userDashboard,
          userdashboardData: {
            ...state.userDashboard.userdashboardData,
            ...{
              [action.payload.dashboardId]: action.payload,
            },
          },
        },
      };
      return v;
    }
    case types.UPDATE_DASHBOARD_ANALYTICS_PARMS:
      return {
        ...state,
        [action.payload.name]: action.payload.value,
      };
    case types.RESET_PARAMS:
      return{
        ...state,
        formatDate: state.initialState.fromDate,
        toDate: state.initialState.toDate,
        system: state.initialState.system,
        branch: state.initialState.branch,
        salesChanelId:state.initialState.salesChanelId,
        agentId:state.initialState.agentId,
      }
    case types.GET_USER_BRANCH_END: 
      return {
        ...state, 
        userBranch: action.payload,
      }
    case types.GET_AGENT_LIST_END: 
      return {
        ...state, 
        agentsList: action.payload,
      }
    case types.GET_SALE_CHANNEL_LIST_END: 
      return {
        ...state, 
        salesChannelList: action.payload,
      }
    case types.SAVE_DROPDOWN_VALUES_END:
      return {
        ...state,
        multipleSelectedValues: action.payload,
      }
    case types.SET_SELECTED_AGENTS:
      return {
        ...state,
        selectedAgents: action.payload,
      };
    default:
      return state;
  }
}
